const supportedOperations = new WeakMap();
const resources = new WeakMap();
const clients = new WeakMap();
export class Operation {
    constructor(supportedOperation, alcaeus, resource) {
        if (!supportedOperation) {
            throw new Error('Missing supportedOperation parameter');
        }
        if (!alcaeus) {
            throw new Error('Missing alcaeus parameter');
        }
        if (!resource) {
            throw new Error('Missing resource parameter');
        }
        supportedOperations.set(this, supportedOperation);
        resources.set(this, resource);
        clients.set(this, alcaeus);
    }
    get method() {
        return this.supportedOperation.method;
    }
    get expects() {
        return this.supportedOperation.expects;
    }
    get returns() {
        return this.supportedOperation.returns;
    }
    get requiresInput() {
        return this.supportedOperation.requiresInput;
    }
    get title() {
        return this.supportedOperation.title;
    }
    get description() {
        return this.supportedOperation.description;
    }
    get supportedOperation() {
        const supportedOperation = supportedOperations.get(this);
        if (!supportedOperation) {
            throw new Error('Supported operation was not found for operation');
        }
        return supportedOperation;
    }
    get target() {
        const resource = resources.get(this);
        if (resource) {
            return resource;
        }
        throw new Error('Could not determine the target of the operation');
    }
    invoke(body, headers = {}) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const alcaeus = clients.get(this);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return alcaeus.invokeOperation(this, this.target.id, body, headers);
    }
}
//# sourceMappingURL=Operation.js.map